type DataTestAttrProp = {
  'data-test-id': string;
};

export const dataTestAttrProp = (name: string): DataTestAttrProp => {
  return {
    'data-test-id': name,
  };
};
